import { create } from 'zustand';

/**
 * Acting-center context (docs/06 acting-center switcher, docs/05 center scoping).
 * `resolveActingCenter` requires a Super Admin to pass an explicit centerId for center-scoped
 * actions (omitting it throws invalid-argument); a Center Admin is pinned to their claim's
 * centerId. `null` means the global / "All centers" scope for oversight callables.
 *
 * Selection persists across reloads for Super Admins, but is CLEARED on sign-out (docs/05
 * single sign-out clears any persisted acting-center selection).
 */
const STORAGE_KEY = 'aabar.actingCenterId';

interface ActingCenterState {
  /** null = global / all centers. */
  actingCenterId: string | null;
  setActingCenter: (centerId: string | null) => void;
  reset: () => void;
}

function load(): string | null {
  const v = localStorage.getItem(STORAGE_KEY);
  return v && v.length > 0 ? v : null;
}

export const useActingCenterStore = create<ActingCenterState>((set) => ({
  actingCenterId: load(),
  setActingCenter: (centerId) => {
    if (centerId) localStorage.setItem(STORAGE_KEY, centerId);
    else localStorage.removeItem(STORAGE_KEY);
    set({ actingCenterId: centerId });
  },
  reset: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ actingCenterId: null });
  },
}));
